import { GridSortDirection } from "@mui/x-data-grid/models";
import i18n from "i18next";

export const JobPricingReportConstants = {
  DEFAULT_PERCENTILE_VALUES: ["0.1", "0.25", "0.5", "0.75", "0.9"],
  DEFAULT_PERCENTILE_LABELS: ["P10", "P25", "P50", "P75", "P90"],
  DEFAULT_AVERAGE_PERCENTILE_LABELS: "Average",
  DEFAULT_AVERAGE_PERCENTILE_VALUES: "9999.00",
  DEFAULT_PERCENTILE_DATA: {
    percentile: "0.5",
    percentileDisplay: "P50"
  },
  DEFAULT_LANGUAGE_CODE: "EN",
  MINIMUM_PRECENTILE_SELECTION: 1,
  MAXIMUM_PERCENTILE_SELECTION: 6,
  PERVIOUS_YEAR_COMPENSATION_KEY: "10000",
  TABLE_ROWS_PER_PAGE_OPTIONS: [10, 25, 50, 100],
  TABLE_DEFAULT_PAGE_SIZE: 10,
  TABLE_SORTING_ORDER: ["desc", "asc"] as GridSortDirection[],
  TABLE_DEFAULT_SORT: "desc" as GridSortDirection,
  get NO_DATA_AVAILABLE_MSG() {
    return i18n.t("pa.noDataAvailable");
  },
  get BASE_SALARY() {
    return i18n.t("pa.baseSalary");
  },
  get TOTAL_CASH_COMPENSATION() {
    return i18n.t("pa.totalCashCompensation");
  },
  get MY_ORG() {
    return i18n.t("pa.myOrg");
  },
  get MY_ORG_AVG() {
    return `${i18n.t("pa.myOrgavg")}:`;
  },
  get TARGET() {
    return i18n.t("pa.target");
  },
  get TARGET_MARKET() {
    return `${i18n.t("pa.targetMarket")}:`;
  },
  get JOB_PRICING_EXPORT_NAME() {
    return i18n.t("pa.jobPricingReport");
  }
};

export const JobPricingCategory = {
  JOB: "job",
  FUNCTION: "function",
  GRADE: "grade"
};

export const JobPricingListTabLabel = {
  JOB: "Jobs",
  FUNCTION: "Functions",
  GRADE: "Grades"
};
